const dataConfig = {
    AppName : process.env.REACT_APP_NAME,
    ApiURL : process.env.REACT_APP_API_URL,
    ApiFrontEnd : process.env.REACT_APP_API_FRONT_URL,
    localSet:{
        // format: 'DD/MM/YYYY HH:mm:ss',
        "separator": " - ",
        "applyLabel": "ตกลง",
        "cancelLabel": "ยกเลิก",
        "fromLabel": "จาก",
        "toLabel": "ถึง",
        "monthNames": [  "มกราคม", "กุมภาพันธ์", "มีนาคม",  "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ],
        "daysOfWeek": ['อา','จ','อ','พ','พฤ','ศ','ส']
      },
    money: Intl.NumberFormat("th-TH", {
        minimumFractionDigits: 2,
      }),
    money_int: Intl.NumberFormat("th-TH", {
        minimumFractionDigits: 0,
    })
}

export default dataConfig
